import { cn } from '@c2fo/liquidity';

const Divider = ({ vertical = false }: { vertical?: boolean }) => (
  <div className={cn('h-[1px] w-full bg-stroke', { 'h-4 w-[1px]': vertical })} />
);

export default Divider;
